function addAllItems(variantIdArray, clickedButton) {
  var newVariantIdArray = variantIdArray.split(',');
  
  // Get the cart notification element
  const cartNotification = document.querySelector('cart-notification');
  if (!cartNotification) {
    console.error('Cart notification element not found');
    return;
  }

  // Get the plant height from the hidden input (for the plant, not the pot)
  const plantHeightInput = document.getElementById('plant-height');
  const plantHeight = plantHeightInput ? plantHeightInput.value : null;
  
  var product_data = newVariantIdArray.map((variantId, index) => {
    // The plant is typically the second item (index 1), pot is first (index 0)
    // Add Plant Height property only to the plant, not the pot
    if (plantHeight && index === 1) {
      return {
        quantity: 1, 
        id: variantId,
        properties: {
          'Plant Height': plantHeight
        }
      };
    }
    return {quantity: 1, id: variantId};
  })
  
  // Create FormData to match the main add to cart behavior
  const formData = new FormData();
  
  // Add items as form data with properties
  product_data.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.id);
    formData.append(`items[${index}][quantity]`, item.quantity);
    
    // Add properties if they exist
    if (item.properties) {
      Object.keys(item.properties).forEach(key => {
        formData.append(`items[${index}][properties][${key}]`, item.properties[key]);
      });
    }
  });
  
  // Add sections to get updated cart data for the popup
  const sectionsToRender = cartNotification.getSectionsToRender().map((section) => section.id);
  sectionsToRender.forEach(section => {
    formData.append('sections[]', section);
  });
  formData.append('sections_url', window.location.pathname);
  
  // Add loading state to button
  if (clickedButton) {
    clickedButton.setAttribute('aria-disabled', true);
    clickedButton.classList.add('loading');
  }
        
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      // Handle error
      alert(response.description);
      return;
    }
    
    // Store the variant IDs that were just added so the notification can display them
    window.recentlyAddedItems = newVariantIdArray;
    
    // Show the cart notification popup (same as main add to cart button)
    cartNotification.renderContents(response);
  })
  .catch((e) => {
    console.error('Error:', e);
    alert('There was an error adding items to cart. Please try again.');
  })
  .finally(() => {
    // Remove loading state
    if (clickedButton) {
      clickedButton.classList.remove('loading');
      clickedButton.removeAttribute('aria-disabled');
    }
  });
}
